import clsx from "clsx";
import debounce from "debounce";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Alert from "common/components/ui/Alert";

export default function TargetingInfo() {
  const [isVisible, setIsVisible] = useState(false);

  const canFitInViewport = document.body.offsetHeight <= window.innerHeight;

  const handleScroll = useCallback(
    debounce(() => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight ||
        canFitInViewport
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }, 200),
    [],
  );

  useEffect(() => {
    if (canFitInViewport) {
      setIsVisible(true);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const { t } = useTranslation("campaigns", {
    keyPrefix: "targetingSetup",
  });

  return (
    <Alert
      className={clsx(
        "fixed bottom-28 left-1/2 w-10/12 max-w-[600px] -translate-x-1/2 transition-[opacity,visibility] duration-200 lg:bottom-24 lg:ml-[72px]",
        isVisible ? "visible opacity-100" : "invisible opacity-0",
      )}
    >
      <span className="text-xs-bold">{t("previewTargetingTitle")}.</span>{" "}
      {t("previewTargetingSubtitle")}
    </Alert>
  );
}
